import { DocumentoMatriculaRapidaDTO } from 'src/app/models/agendamento/documentoMatriculaRapidaDTO';
import { TIPO_FORMA_INGRESSO } from '../../../../../config/tipo-forma-ingresso.config';
import { Component, OnInit } from '@angular/core';
import { ConfiguracaoDocumentoDTO } from 'src/app/models/documentacao/configuracaoDocumentoDTO';
import { ParametroAnaliseDocumentoDTO } from 'src/app/models/documentacao/parametroAnaliseDocumentoDTO';
import { FormaIngressoDTO } from 'src/app/models/agendamento/formaIngressoDTO';
import { PopoverController } from '@ionic/angular';
import { SubstitutoMatriculaRapidaDTO } from 'src/app/models/documentacao/substitutoMatriculaRapidaDTO';

@Component({
  selector: 'app-popover-selecionar-substitutos',
  templateUrl: './popover-selecionar-substitutos.component.html',
  styleUrls: ['./popover-selecionar-substitutos.component.scss'],
})
export class PopoverSelecionarSubstitutosComponent implements OnInit {

  documentoMatriculaRapidaPrincipal: DocumentoMatriculaRapidaDTO;
  padMatricula: ParametroAnaliseDocumentoDTO;
  formaIngresso: FormaIngressoDTO;


  


  constructor( private popoverController: PopoverController ) { }

  ngOnInit() {
    this.filterDocuments();
  }

  filterDocuments() {
    if (!this.formaIngresso || !this.formaIngresso.tipo) {
      return; // Retorna se formaIngresso ou formaIngresso.tipo não estiver definido
    }
  
    this.padMatricula.configuracoesDocumentos = this.padMatricula.configuracoesDocumentos.filter(doc =>
      (doc.enem && this.formaIngresso.tipo === TIPO_FORMA_INGRESSO.ENEM) ||
      (doc.vestibularOnline && this.formaIngresso.tipo === TIPO_FORMA_INGRESSO.VESTIBULAR_ONLINE) ||
      (doc.vestibularPresencial && this.formaIngresso.tipo === TIPO_FORMA_INGRESSO.VESTIBULAR_PRESENCIAL) ||
      (doc.transferenciaExterna && this.formaIngresso.tipo === TIPO_FORMA_INGRESSO.TRANSFERENCIA) ||
      (doc.portadorDiploma && this.formaIngresso.tipo === TIPO_FORMA_INGRESSO.PORTADOR_DIPLOMA) ||
      (doc.readmissaoPosAbandono && this.formaIngresso.tipo === TIPO_FORMA_INGRESSO.REINGRESSO_POS_ABANDONO)
    );
  }


  addSubstitute(event: any, configuracaoDocumento: ConfiguracaoDocumentoDTO){

    if(!this.documentoMatriculaRapidaPrincipal.substitutos){
      this.documentoMatriculaRapidaPrincipal.substitutos = [];
    }

    const index = this.documentoMatriculaRapidaPrincipal
                      .substitutos
                      .findIndex(doc => doc.configuracaoDocumento.id === configuracaoDocumento.id);
    
    if(event.target.checked){
        if(index === -1) { // Documento não está na lista, então adicione
          
          let substituto = new SubstitutoMatriculaRapidaDTO();
          substituto.configuracaoDocumento = configuracaoDocumento;

          this.documentoMatriculaRapidaPrincipal.substitutos.push(substituto);
        }
    } else {
        if(index !== -1) { // Documento está na lista, então remova
          this.documentoMatriculaRapidaPrincipal.substitutos.splice(index, 1);
        }
    }

  }


  docAdded(configuracaoDocumento: ConfiguracaoDocumentoDTO): boolean{
    
    if(!this.documentoMatriculaRapidaPrincipal.substitutos){
      this.documentoMatriculaRapidaPrincipal.substitutos = [];
      return;
    }

    const index = this.documentoMatriculaRapidaPrincipal
                      .substitutos
                      .findIndex(doc => doc.configuracaoDocumento.id === configuracaoDocumento.id);
    
    return index>=0;
  }

  

  cancel(){
    this.popoverController.dismiss(null);
  }

  confirm(){
    this.popoverController.dismiss(this.documentoMatriculaRapidaPrincipal);
  }


}


